import React from 'react';
import { getContext } from 'common';
import _merge from 'lodash/merge';
import CloseIcon from '@nokia-csf-uxr/ccfk-assets/CloseIcon';
import IconButton, { IconButtonProps } from 'components/IconButton';
import Styled from './styles';

export interface FilterFieldClearButtonProps extends React.ComponentPropsWithRef<'div'> {
  /** Forward props to the IconButton component. */
  iconButtonProps?: Partial<IconButtonProps>;
  /** Pass in your <IconButton /> here.  */
  children?: React.ReactNode;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** FilterFieldClearButton component.
 * Any other props than the explicitly defined props will be provided to the IconButton component. */
const FilterFieldClearButton = React.forwardRef<HTMLElement, FilterFieldClearButtonProps>((props: FilterFieldClearButtonProps, ref) =>
  getContext(({ RTL, theme }) => {
    const { children, iconButtonProps, theme: themeProp, ...otherProps } = props;

    const resolvedTheme = _merge({}, theme.FILTER_FIELD, themeProp);
    return (
      <Styled.FilterFieldClearButton ref={ref} $theme={resolvedTheme} $rtl={RTL} {...otherProps}>
        {children || (
          <IconButton {...iconButtonProps}>
            <CloseIcon />
          </IconButton>
        )}
      </Styled.FilterFieldClearButton>
    );
  }));

FilterFieldClearButton.displayName = 'FilterFieldClearButton';
FilterFieldClearButton.defaultProps = {
  iconButtonProps: {},
  children: undefined,
  theme: {}
};

/* Exports */
export { FilterFieldClearButton as default };
